import React, { useEffect, useRef, useState } from 'react';
import { QUERY_LANDLORD_NAMES } from './query';
import { useQuery } from '@apollo/client';
import NewSearch from 'common/components/new-search';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const LandlordNamesFilter = props => {
  const { onChange, selectedIds } = props;
  const [landlordNames, setLandlordNames] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [query, setQuery] = useState('');
  const hasMore = useRef(true);

  const { t } = useTranslation();
  const pageSize = 20;

  const { data: landlordInfo, loading: getLandlordLoading } = useQuery(QUERY_LANDLORD_NAMES, {
    variables: {
      query,
      pageNumber,
      pageSize,
    },
    fetchPolicy: 'network-only',
  });

  const handleScrollEnd = () => {
    if (!hasMore.current) return;
    setPageNumber(prevPageNumber => prevPageNumber + 1);
  };

  const handleSearch = value => {
    setPageNumber(1);
    setLandlordNames([]);
    setQuery(value);
    hasMore.current = true;
  };

  useEffect(() => {
    if (!getLandlordLoading) {
      const result =
        landlordInfo?.search?.edges?.map(item => ({
          label: item?.node?.name,
          value: item?.node?.id,
        })) || [];
      if (result.length < pageSize) {
        hasMore.current = false;
      } else {
        hasMore.current = true;
      }
      if (result.length) {
        setLandlordNames(prev => [...prev, ...result]);
      }
    }
  }, [getLandlordLoading]);

  return (
    <NewSearch
      key="landlordName"
      options={landlordNames}
      onChange={items => {
        onChange(items);
      }}
      onSearch={handleSearch}
      placeholderInfo={{
        title: t('cms:cms.landlord.landlord_name.table'),
        filteredTitle: t('cms:cms.landlord.landlord_name.table'),
      }}
      defaultCheckedFilters={typeof selectedIds === 'string' ? [selectedIds] : selectedIds || []}
      loading={getLandlordLoading}
      onScrollEnd={handleScrollEnd}
    />
  );
};
LandlordNamesFilter.propTypes = { onChange: PropTypes.func };
export default LandlordNamesFilter;
